import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindowSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { BrowserWindow } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { AppMonitoringApi, AppMonitoringSiteConfig } from './types'
import { getMonitoringClientFunctionFactory } from './getMonitoringClientFunction'
import { addRerouteDataToSentryEvent, isSentryEventFromNonWixTpa } from './addRerouteDataToSentryEvent'

/**
 * This is a feature.
 * You can get your configuration from site-assets and viewer-model injected into your feature
 */
export const AppMonitoring = withDependencies<AppMonitoringApi>(
	[named(SiteFeatureConfigSymbol, name), BrowserWindowSymbol],
	(siteFeatureConfig: AppMonitoringSiteConfig, window: NonNullable<BrowserWindow>) => {
		const getMonitoringConfig = (appId: string) =>
			siteFeatureConfig.appsWithMonitoring.find((app) => app.appId === appId)

		return {
			featureName: name,
			addRerouteDataToSentryEvent,
			getMonitoringClientFunction: (options) => {
				const config = getMonitoringConfig(options.appId)
				return getMonitoringClientFunctionFactory({
					config,
					sentry: window.Sentry,
					sentryTransport: siteFeatureConfig.sentryTransport, // for tests
				})(options)
			},
			getMonitoringConfig,
			isSentryEventFromNonWixTpa,
		}
	}
)
